module.exports = __webpack_public_path__ + "static/media/Ellipse 17.d6dc8ac3.png";